import React from "react";
import { TextField } from "@telia/teddy";
import "./NumberField.less";

interface NumberFieldProps {
    isDisabled?: boolean;
    labelText?: string;
    placeholder: string;
    selectedPhoneNumber: string;
    setSelectedPhoneNumber: (phoneNumber: string) => void;
}

const NumberField: React.FC<NumberFieldProps> = ({
    selectedPhoneNumber,
    setSelectedPhoneNumber,
    labelText,
    placeholder,
    isDisabled = false,
}) => (
    <div className="number-field spacer-top">
        <TextField disabled={isDisabled} className="number-field__input">
            {labelText && <TextField.Label>{labelText}</TextField.Label>}
            <TextField.Input
                type="tel"
                data-di-mask
                value={selectedPhoneNumber}
                onChange={(event) => setSelectedPhoneNumber(event.target.value)}
                placeholder={placeholder}
            />
        </TextField>
    </div>
);

export default NumberField;
